<div style="position: relative; height: 100%;">
  <app-line-chart [barChartData]="chartData" [barChartOptions]="chartOptions" [expanded]="expanded" [isMonitorMode]="isMonitorMode" [loading]="loading" style="height: 100%; display: block;"></app-line-chart>
  @if (expanded) {
  <button nz-button nzType="primary" nzShape="circle" (click)="exportChart()"
    style="position: absolute; top: 0; right: 0; z-index: 10;" nz-tooltip nzTooltipTitle="Exportar Gráfico">
    <i nz-icon nzType="download"></i>
  </button>
  }
</div>